import React from 'react'
import { Card, Row, Col, Badge } from 'react-bootstrap'
import { connect } from 'react-redux'
import { DEPARTMENT_HEADS } from '../../constants/roles'
import { getUnenrolledStudentInfo } from '../../redux/actions/unenrolledStudent'

const CandidateInfo = ({ auth:{ user }, info }) => {

  return (<Card bg="secondary" text="white" border="secondary" className="mt-5">
    <Card.Header className="d-flex justify-content-md-between align-items-center">
      <h4>
        Información del Estudiante
      </h4> 
      {
        user.role && (
            <h4>
              No. de Control -
              <Badge variant='dark' className='ml-1'>
                {
                  info.inscripcion && info.inscripcion.numero_de_control
                }
              </Badge>
            </h4> 
          )
      }
      {
        info.inscripcion && (info.inscripcion.equivalencia === 1 ? <Badge variant={'info'}><h5 className='m-0'>{'Equivalencia'}</h5></Badge> : null)
      }
      {
        info.inscripcion && (info.inscripcion.traslado === 1 ? <Badge variant={'info'}><h5 className='m-0'>{'Traslado'}</h5></Badge> : null)
      }
      {
        info.inscripcion && <Badge variant={info.inscripcion.documentacion === 0 ? 'info' : info.inscripcion.documentacion === 1 ? 'success' : 'warning'}><h5 className='m-0'>{info.inscripcion.documentacion === 0 ? 'Listo para revisar' : info.inscripcion.documentacion === 1 ? 'Aprobado y validado' : 'Faltan documentos'}</h5></Badge>
      }
      {  
        info.inscripcion && <Badge variant={info.inscripcion.inscrito ? 'success' : 'danger'}><h5 className='m-0'>{info.inscripcion.inscrito ? 'Inscrito' : 'No Inscrito'}</h5></Badge>
      }
    </Card.Header>
    <Card.Body className="body-card">
      <Row>
        <Col xs={{ span: 12 }} md={{ span: 4 }}>
          <Row>
            <Col xs={{ span: 6 }} md={{ span: 4 }}>
              <b>Nombre :</b>
            </Col>
            <Col xs={{ span: 6 }} md={{ span: 7 }}>
              { info.nombre }
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 6 }} md={{ span: 4 }}>
              <b>Apellidos :</b>
            </Col>
            <Col xs={{ span: 6 }} md={{ span: 7 }}>
              {`${info.primer_apellido} ${info.segundo_apellido}`}
            </Col>
          </Row>
          {
           user.role &&  
            <Row>
              <Col xs={{ span: 6 }} md={{ span: 4 }}>
                <b>NIP :</b>
              </Col>
              <Col xs={{ span: 6 }} md={{ span: 7 }}>
                { info.inscripcion && info.inscripcion.nip }
              </Col>
            </Row>
          }
        </Col>
        <Col xs={{ span: 12 }} md={{ span: 4 }}>
          <Row>
              <Col xs={{ span: 6 }} md={{ span: 4 }}>
                <b>CURP :</b>
              </Col>
              <Col xs={{ span: 6 }} md={{ span: 7 }}>
                {info.curp}
              </Col>
          </Row>
          <Row>
            <Col xs={{ span: 6 }} md={{ span: 4 }}>
              <b>Correo :</b>
            </Col>
            <Col xs={{ span: 6 }} md={{ span: 7 }}>
              {info.correo}
            </Col>
          </Row>
          { (DEPARTMENT_HEADS.includes(user.role) && info.inscripcion && info.inscripcion.inscrito) ?
            <Row>
              <Col xs={{ span: 6 }} md={{ span: 4 }}>
                <b>Inscrito por :</b>
              </Col>
              <Col xs={{ span: 6 }} md={{ span: 7 }}>
                <Badge variant='info'><h6 className='m-0'>{info.inscripcion.inscrito_por.full_name}</h6></Badge>
              </Col>
            </Row> : null
          }
        </Col>
        <Col xs={{ span: 12 }} md={{ span: 4 }}>
          <Row>
            <Col xs={{ span: 6 }} md={{ span: 4 }}>
              <b>Tel&eacute;fono :</b>
            </Col>
            <Col xs={{ span: 6 }} md={{ span: 7 }}>
              {info.telefono_celular}
            </Col>
          </Row>
          <Row>
            <Col xs={{ span: 6 }} md={{ span: 4 }}>
              <b>Carrera :</b>
            </Col>
            <Col xs={{ span: 6 }} md={{ span: 7 }}>
              { info.inscripcion && info.inscripcion.carrera.nombre}
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  </Card>)
}

const mapStateToProps = state => ({
  unenrolledStudent : state.unenrolledStudent,
  auth: state.auth
})

const dispatchStateToProps = {
  getUnenrolledStudentInfo
}

export default connect(mapStateToProps, dispatchStateToProps)(CandidateInfo)